import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

export const ProtectedRoute = ({ children, requiredRoles = [], requiredAdminRoles = [] }) => {
  const { user, loading, isAuthenticated } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check role requirement
  if (requiredRoles.length > 0 && !requiredRoles.includes(user?.role)) {
    // Redirect regular users to their dedicated pages (not dashboard)
    return <Navigate to="/my-tickets" replace />;
  }

  // Check admin_role requirement (for granular admin access)
  if (requiredAdminRoles.length > 0) {
    const userAdminRole = user?.admin_role;
    // super_admin always has access
    if (userAdminRole !== 'super_admin' && !requiredAdminRoles.includes(userAdminRole)) {
      // Redirect to appropriate dashboard based on their role
      if (userAdminRole === 'finance') {
        // Finance dashboard backend endpoints are not yet implemented (all return 404).
        // Route finance admins to the working analytics dashboard until /admin/finance is built.
        return <Navigate to="/admin/analytics" replace />;
      } else if (userAdminRole === 'support') {
        return <Navigate to="/admin/support" replace />;
      } else if (userAdminRole === 'moderator') {
        return <Navigate to="/admin/moderator" replace />;
      }
      return <Navigate to="/my-tickets" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
